export const beautifyDate = (date?: string) => {
  if (!date) {
    return "-";
  }
  return new Date(date).toLocaleString();
};
